import { Routes } from '@angular/router'
import { ImprintComponent } from 'src/app/pages/imprint/imprint.component'
import { BuyComponent } from 'src/app/pages/buy/buy.component'

export const routes: Routes = [{
  path: 'impressum',
  component: ImprintComponent,
}, {
  path: "**",
  component: BuyComponent,
}]
